import {Component, inject, OnInit, signal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ParishOrganizationService} from '../../../../core/services/parishOrganization.service';
import {MaterialModule} from '../../../../core/modules/material.module';
import {SharedModule} from '../../../../core/modules/shared.module';

@Component({
  selector: 'edit-parish-orgs',
  templateUrl: './edit-parish-orgs.component.html',
  styleUrls: ['./edit-parish-orgs.component.scss'],
  standalone: true,
  imports: [
    MaterialModule,
    SharedModule
  ]
})
export class EditParishOrgsComponent implements OnInit {
  public dialogRef = inject(MatDialogRef<EditParishOrgsComponent>);
  public data = inject(MAT_DIALOG_DATA);
  private parishOrganizationService = inject(ParishOrganizationService);

  user = signal<any>(null);
  parishOrgs = signal<any[]>([]);
  parishOrganizations = signal<any[]>([]);
  activities = signal<any[]>([]);

  ngOnInit() {
    const userData = this.data?.user || this.data;
    this.user.set(userData);
    this.parishOrgs.set(userData?.learningPathsParticipantParishOrgs || this.data?.parishOrgs || []);

    this.parishOrganizationService.parishOrganizationsOpen().subscribe((res: any) => {
      this.parishOrganizations.set(res?.parishOrganizations || []);
      this.activities.set(res?.functionType || []);
    });
  }

  onParishChange(item: any, newValue: any) {
    this.parishOrgs.update(orgs =>
      orgs.map(o => o === item ? { ...o, parishOrganizationId: newValue } : o)
    );
  }

  onActivityChange(item: any, newValue: any) {
    this.parishOrgs.update(orgs =>
      orgs.map(o => o === item ? { ...o, activityId: newValue } : o)
    );
  }

  addParishOrg() {
    const firstParishId = this.parishOrganizations().length > 0 ? this.parishOrganizations()[0].id : null;
    const firstActivityId = this.activities().length > 0 ? this.activities()[0].id : null;

    const newOrg = {
      parishOrganizationId: firstParishId,
      activityId: firstActivityId
    };

    this.parishOrgs.update(orgs => [...orgs, newOrg]);
  }

  removeParishOrg(index: number) {
    this.parishOrgs.update(orgs => orgs.filter((_, i) => i !== index));
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close( this.parishOrgs());
  }
}
